<template>
    <svg x="133" y="152" viewBox="0 0 128 80" id="sd-shapes">
        <transition
            @before-enter="beforeEnter"
            @enter="enter"
            @after-enter="afterEnter"
            @before-leave="beforeLeave"
            @leave="leave"
            @after-leave="afterLeave"
            :css="false"
            mode="out-in"
        >
            <component v-bind:is="`sd-${shape}`" :fill="fill"></component>
        </transition>
    </svg>
</template>

<script>
import shapes from './shapes'
import animations from './shapes/animations'

export default {
    components: {
        ...shapes
    },

    props: {
        fill: {
            type: String,
            default: '#ffffff'
        },

        shape: {
            type: String,
            default: 'bars'
        }
    },

    methods: {
        beforeEnter(group) {
            animations[group.id].beforeEnter &&
                animations[group.id].beforeEnter(group)
        },

        enter(group, done) {
            if (animations[group.id].enter) {
                animations[group.id].enter(group, done)
            } else {
                done()
            }
        },

        afterEnter(group) {
            animations[group.id].afterEnter &&
                animations[group.id].afterEnter(group)
        },

        beforeLeave(group) {
            animations[group.id].beforeLeave &&
                animations[group.id].beforeLeave(group)
        },

        leave(group, done) {
            if (animations[group.id].leave) {
                animations[group.id].leave(group, done)
            } else {
                done()
            }
        },

        afterLeave(group) {
            animations[group.id].afterLeave &&
                animations[group.id].afterLeave(group)
        }
    }
}
</script>

<style>
#sd-shapes {
    overflow: visible;
}
</style>
